import { useMutation } from "react-query";
import http from "infra/http";
import { useCurrentTenant } from "core/features/auth/tenant.store";

function useToggleStatusContaBancaria(tenantId?: string) {
  const { tenant } = useCurrentTenant();
  const _tenantId = tenantId || tenant.id;

  return useMutation(
    `/v1/tenants/${_tenantId}/conta-bancaria/:id/mudar-status`,
    (id: string) => {
      const apiRoute = `/v1/tenants/${_tenantId}/conta-bancaria/${id}/mudar-status`;

      return http.post(apiRoute, { params: _tenantId });
    },
    {
      retry: false,
    }
  );
}

export default useToggleStatusContaBancaria;
